// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"01d94833","644":"9af4b49f","675":"0843f776","787":"20893520","962":"0d27b3de"}[chunkId] + ".chunk.js";
};